import AdminLayout from "../../../components/admin/layout/AdminLayout";
import styles from "./AdminMainPage.module.css"
import AdminProjectInfoCard from "../../../components/admin/dashboard/AdminProjectInfoCard";
import AdminContractInfoCard from "../../../components/admin/dashboard/AdminContractInfoCard";
import AdminRequestTable from "../../../components/admin/dashboard/AdminRequestTable";
import AdminGraphCard from "../../../components/admin/dashboard/AdminGraphCard";
//어드민 메인 대시보드 페이지
const AdminMainPage: React.FC = () => {
    return (
        <AdminLayout>
            <div className={(styles.dashboardGrid)}>
                <div className={styles.topRow}>
                    {/*어드민 계약 정보 카드*/}
                    <AdminContractInfoCard/>
                    {/*어드민 프로젝트 정보 카드*/}
                    <AdminProjectInfoCard/>
                </div>
                <div className={styles.bottomRow}>
                    {/*어드민 통계 그래프 카드*/}
                    <AdminGraphCard/>
                    {/*어드민 요청 테이블*/}
                    <AdminRequestTable/>
                </div>
            </div>
        </AdminLayout>
    )
}
export default AdminMainPage